export default __webpack_public_path__ + "static/Entenda0105-08e5f9b1e864e83f788d5bdfd0cce369.jpg";